var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0163 18.4282V5.82654L31.7073 11.2466L33.8753 8.9431L26.0163 1.49052V1.35501H25.8808L24.3902 0L23.0352 1.35501H22.8997V1.49052L15.3117 8.9431L17.4797 11.1111L22.8997 5.69107V18.1572H0V48.916H49.0515L49.187 18.1572H26.0163V18.4282ZM45.935 45.935H3.11654V21.4092H22.8997V42.6829H26.0163V21.4092H46.0705L45.935 45.935Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Upload.191af0867cc989c181b8ab5e8de63d2e.svg";